var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "container-withdrawal",
      class: [_vm.$i18n.locale === "ar" ? "ar-style" : "", _vm.packageName],
    },
    [
      _c(
        "div",
        {
          staticClass: "custom-nav-block",
          style: `padding-top:${_vm.barHeight}px; background-color: #f9f9fb;`,
        },
        [
          _c("van-nav-bar", {
            staticClass: "van-bar",
            attrs: { title: "", "left-arrow": "" },
            on: { "click-left": _vm.handleBack },
            scopedSlots: _vm._u([
              {
                key: "left",
                fn: function () {
                  return [
                    _c("img", {
                      staticClass: "left-nav",
                      attrs: {
                        src: require("@/assets/packageAssets/common/arrow05.png"),
                        alt: "",
                      },
                    }),
                    _vm.walletType == 0
                      ? _c("span", { staticClass: "tit-left" }, [
                          _vm._v(
                            _vm._s(_vm.$t("lang.sevenKeepSignin.withdraw"))
                          ),
                        ])
                      : _vm._e(),
                    _vm.walletType == 1
                      ? _c("span", { staticClass: "tit-left" }, [
                          _vm._v(_vm._s(_vm.$t("lang.wd.withdrawalAgent"))),
                        ])
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
              {
                key: "right",
                fn: function () {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "tit-right",
                        on: {
                          click: function ($event) {
                            return _vm.jumpPathWithQuery(
                              "/withdrawal-details",
                              _vm.walletType
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("lang.mybean.details")))]
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _c("div", { staticClass: "main" }, [
        _c("div", { staticClass: "head" }, [
          _c("div", { staticClass: "head-money" }, [
            _c("div", { staticClass: "my-balance my" }, [
              _c("div", { staticClass: "my-balance-tit" }, [
                _c("span", [_vm._v(_vm._s(_vm.$t("lang.wd.myBalance")))]),
                _c("div", { staticClass: "my-balance-scale" }, [
                  _c("img", {
                    attrs: { src: _vm.getMatchImg("beans"), alt: "" },
                  }),
                  _c("span", [_vm._v(_vm._s(_vm.beansPerDollar) + " ≈")]),
                  _c("span", [_vm._v(_vm._s(_vm.currencyCode) + " ")]),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.handleNumberTransformK(_vm.currencyAmountPerDollar)
                      )
                    ),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "my-balance-beans" }, [
                _c("div", { staticClass: "my-beans" }, [
                  _c("span", { staticClass: "beans-img" }, [
                    _c("img", {
                      attrs: { src: _vm.getMatchImg("beans"), alt: "" },
                    }),
                    _vm._v(_vm._s(_vm.beans) + " "),
                  ]),
                  _c("span", { staticClass: "beans-tran" }, [
                    _vm._v(
                      "≈" +
                        _vm._s(_vm.currencyCode) +
                        " " +
                        _vm._s(_vm.handleNumberTransformK(_vm.currencyAmount))
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "amount" }, [
            _c("span", { staticClass: "tit" }, [
              _vm._v(_vm._s(_vm.$t("lang.wd.withdrawAmount"))),
            ]),
            _c(
              "div",
              { staticClass: "amount-num" },
              _vm._l(_vm.moneyList, function (item, index) {
                return _c("div", { key: index, staticClass: "price-wrapper" }, [
                  _c(
                    "div",
                    {
                      staticClass: "price",
                      class: {
                        priceActive: Number(_vm.priceActive) == item,
                        onSelecePrice: _vm.minPrice && item < _vm.minPrice,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handleChoose(item)
                        },
                      },
                    },
                    [
                      item
                        ? _c("i", [
                            _vm._v(" " + _vm._s(item * 10) + " "),
                            _c("img", {
                              attrs: {
                                src: _vm.getMatchImg("beans"),
                                alt: "",
                                width: "16",
                              },
                            }),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ])
              }),
              0
            ),
          ]),
        ]),
        _c("div", { staticClass: "bind" }, [
          _c(
            "div",
            {
              staticClass: "method account",
              on: {
                click: function ($event) {
                  return _vm.handleToBindAccound(
                    _vm.walletType,
                    _vm.locaFlag,
                    _vm.locaCode,
                    _vm.withdrawAccounts,
                    _vm.priceActive
                  )
                },
              },
            },
            [
              _c("div", { staticClass: "number" }, [
                _c("img", {
                  attrs: {
                    src: require("@/assets/packageAssets/views/P1_Girls/Withdrawal/vava/dollar.png"),
                    alt: "",
                  },
                }),
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("lang.wd.withdrawalMethod"))),
                ]),
              ]),
              _c("div", { staticClass: "arrow" }, [
                _c(
                  "div",
                  { staticClass: "arrow-box" },
                  [
                    !_vm.withdrawalMethod
                      ? _c("i", [_vm._v(_vm._s(_vm.$t("lang.bind")))])
                      : _c("div", { staticClass: "bind-accound" }, [
                          _c("img", {
                            attrs: {
                              src: _vm._f("imgPath")(_vm.icon),
                              alt: "",
                            },
                          }),
                          _c("i", [_vm._v(_vm._s(_vm.withdrawalMethod))]),
                        ]),
                    _c("van-icon", {
                      staticClass: "arrow-icon",
                      attrs: { name: "arrow" },
                    }),
                  ],
                  1
                ),
              ]),
            ]
          ),
          _vm.withdrawalMethod && !(_vm.withdrawalMethod == "PIX")
            ? _c("div", { staticClass: "feeUsdt arRToLeft" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      (_vm.feeUsdtMap[_vm.priceActive] || [])[0] || "Fee 2%"
                    ) +
                    " "
                ),
              ])
            : _vm._e(),
        ]),
        _c(
          "div",
          {
            class: [
              "withdraw-btn",
              _vm.priceActive &&
              _vm.withdrawalMethod &&
              _vm.priceActive * 10 <= _vm.beans
                ? "withdrawAtc"
                : "",
            ],
            on: { click: _vm.handleDialogClickWithdraw },
          },
          [_vm._v(" " + _vm._s(_vm.$t("lang.sevenKeepSignin.withdraw")) + " ")]
        ),
        _c("div", { staticClass: "withdraw-rules" }, [
          _c("span", [_vm._v(_vm._s(_vm.$t("lang.wd.rules")))]),
          _c("div", [
            _c("span", [_vm._v(_vm._s(_vm.$t("lang.wd.rules1-1")))]),
            _c("span", [_vm._v(" " + _vm._s(_vm.minBeansPerDollar) + " ")]),
            _c("span", [_vm._v(_vm._s(_vm.$t("lang.wd.rules1-2")))]),
          ]),
          _c("div", [
            _c("span", [_vm._v(_vm._s(_vm.$t("lang.wd.rules2-1")))]),
            _vm.walletType == 0
              ? _c(
                  "span",
                  {
                    staticClass: "immediately",
                    on: { click: _vm.handleToImmediately },
                  },
                  [_vm._v(_vm._s(_vm.$t("lang.wd.rules2-2")))]
                )
              : _vm._e(),
          ]),
          _c("div", [_vm._v(_vm._s(_vm.$t("lang.wd.rules3")))]),
          _c("div", [_vm._v(_vm._s(_vm.$t("lang.wd.rules4")))]),
          _c("div", [_vm._v(_vm._s(_vm.$t("lang.wd.rules5")))]),
        ]),
      ]),
      _vm.showDialog
        ? _c(
            "van-dialog",
            {
              attrs: { showConfirmButton: false },
              model: {
                value: _vm.showDialog,
                callback: function ($$v) {
                  _vm.showDialog = $$v
                },
                expression: "showDialog",
              },
            },
            [
              _c("div", { staticClass: "dialog" }, [
                _c("div", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("lang.wd.confirmTit1"))),
                ]),
                _c(
                  "ul",
                  { staticStyle: { width: "100%" } },
                  [
                    _c(
                      "li",
                      { staticClass: "amount-li" },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("lang.instantPayment.amount")) + "："
                          ),
                        ]),
                        _vm.withdrawalMethod === "USDT(TRC20)" ||
                        _vm.withdrawalMethod === "USDT(TRC20/BEP20)" ||
                        _vm.withdrawalMethod === "USDT(BINANCE)"
                          ? [
                              _c("i", [
                                _vm._v(
                                  "≈USDT " +
                                    _vm._s(
                                      _vm.returnFloat(
                                        _vm.myDiv(
                                          _vm.myTimes(_vm.priceActive, 10),
                                          _vm.beansPerDollar
                                        )
                                      )
                                    )
                                ),
                              ]),
                            ]
                          : [
                              _c("i", [
                                _vm._v(
                                  "≈" +
                                    _vm._s(_vm.currencyCode) +
                                    _vm._s(
                                      _vm.returnFloat(
                                        _vm.myTimes(
                                          _vm.myDiv(
                                            _vm.myTimes(_vm.priceActive, 10),
                                            _vm.beansPerDollar
                                          ),
                                          _vm.myDiv(
                                            _vm.currencyAmountPerDollar,
                                            100
                                          )
                                        )
                                      )
                                    )
                                ),
                              ]),
                            ],
                      ],
                      2
                    ),
                    _c("li", { staticClass: "method-li" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("lang.instantPayment.method")) + "："
                        ),
                      ]),
                      _c("img", {
                        attrs: { src: _vm._f("imgPath")(_vm.icon), alt: "" },
                      }),
                      _c("i", [_vm._v(_vm._s(_vm.withdrawalMethod))]),
                    ]),
                    _vm.withdrawalMethod && _vm.withdrawalMethod !== "PIX"
                      ? _c("templete", [
                          _c("li", { staticClass: "amount-li" }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("lang.instantPayment.fee")) + "："
                              ),
                            ]),
                            _c("i", [
                              _vm._v(
                                _vm._s(
                                  _vm.feeUsdt == "0.000"
                                    ? _vm.currencyCode +
                                        _vm.handelFeeTax(
                                          _vm.feeTax,
                                          _vm.currencyAmountPerDollar
                                        )
                                    : +_vm.feeUsdt * 100 + "%"
                                )
                              ),
                            ]),
                          ]),
                          _c(
                            "li",
                            { staticClass: "amount-li" },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("lang.instantPayment.arrivalAmount")
                                  ) + "："
                                ),
                              ]),
                              _vm.withdrawalMethod === "USDT(TRC20)" ||
                              _vm.withdrawalMethod === "USDT(TRC20/BEP20)" ||
                              _vm.withdrawalMethod === "USDT(BINANCE)"
                                ? [
                                    _c("i", [
                                      _vm._v(
                                        "≈USDT " +
                                          _vm._s(
                                            _vm.returnFloat(
                                              _vm.myTimes(
                                                _vm.myDiv(
                                                  _vm.myMinus(
                                                    _vm.myTimes(
                                                      _vm.priceActive,
                                                      10
                                                    ),
                                                    _vm.feeTax
                                                  ),
                                                  _vm.beansPerDollar
                                                ),
                                                _vm.myMinus(1, _vm.feeUsdt)
                                              )
                                            )
                                          )
                                      ),
                                    ]),
                                  ]
                                : [
                                    _c("i", [
                                      _vm._v(
                                        " ≈" +
                                          _vm._s(_vm.currencyCode) +
                                          _vm._s(
                                            _vm.returnFloat(
                                              _vm.myTimes(
                                                _vm.myTimes(
                                                  _vm.myDiv(
                                                    _vm.myMinus(
                                                      _vm.myTimes(
                                                        _vm.priceActive,
                                                        10
                                                      ),
                                                      _vm.feeTax
                                                    ),
                                                    _vm.beansPerDollar
                                                  ),
                                                  _vm.myDiv(
                                                    _vm.currencyAmountPerDollar,
                                                    100
                                                  )
                                                ),
                                                _vm.myMinus(1, _vm.feeUsdt)
                                              )
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ],
                            ],
                            2
                          ),
                        ])
                      : _vm._e(),
                    _c("li", { staticClass: "account-li account-box" }, [
                      _vm.withdrawalMethod == "USDT(TRC20)" ||
                      _vm.withdrawalMethod == "USDT(TRC20/BEP20)"
                        ? _c("span", { attrs: { type: "text" } }, [
                            _vm._v(
                              _vm._s(_vm.$t("lang.wd.TRC20AccountCoinEX")) + ":"
                            ),
                          ])
                        : _c("span", [
                            _vm._v(_vm._s(_vm.$t("lang.wd.phAccount")) + "："),
                          ]),
                      _vm._v(" " + _vm._s(_vm.withdrawAccount) + " "),
                    ]),
                    _vm.withdrawalMethod === "USDT(BINANCE)" &&
                    _vm.accountAddress
                      ? [
                          _c("li", { staticClass: "method-li" }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("lang.wd.address")) + "："),
                            ]),
                            _c("div", { staticClass: "accountAddress-text" }, [
                              _vm._v(_vm._s(_vm.accountAddress)),
                            ]),
                          ]),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _c("div", { staticClass: "btn" }, [
                  _c("span", { on: { click: _vm.handleThinK } }, [
                    _vm._v(_vm._s(_vm.$t("lang.think"))),
                  ]),
                  _c(
                    "span",
                    {
                      staticClass: "confirm-btn",
                      on: { click: _vm.handleConfirm },
                    },
                    [_vm._v(_vm._s(_vm.$t("lang.confirm")))]
                  ),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _c("c-update", {
        attrs: { showDiaUp: _vm.showDiaUp, title: _vm.titleConfirmUp },
      }),
      _c(
        "van-dialog",
        {
          attrs: { showConfirmButton: false, closeOnClickOverlay: "true" },
          on: { close: _vm.cancelAgain },
          model: {
            value: _vm.showDiaConfirm,
            callback: function ($$v) {
              _vm.showDiaConfirm = $$v
            },
            expression: "showDiaConfirm",
          },
        },
        [
          _c("div", { staticClass: "confirm-dialog-wrapper" }, [
            _vm.headline
              ? _c("div", { staticClass: "headline" }, [
                  _vm._v(_vm._s(_vm.headline)),
                ])
              : _vm._e(),
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.titleConfirm)),
            ]),
            _c("div", { staticClass: "btn" }, [
              _c(
                "div",
                {
                  staticClass: "confirm-btn",
                  on: {
                    click: function ($event) {
                      return _vm.jumpPathWithQuery(
                        "/withdrawal-details",
                        _vm.walletType
                      )
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("lang.instantPayment.dialogButtonText1"))
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "confirm-think",
                  on: { click: _vm.cancelAgain },
                },
                [_vm._v(_vm._s(_vm.$t("lang.commonM.k162")))]
              ),
            ]),
          ]),
        ]
      ),
      _c("confirm-dia", { attrs: { con: _vm.con, showDia: _vm.showDia } }),
      _c(
        "van-dialog",
        {
          attrs: {
            title: "",
            showConfirmButton: false,
            showCancelButton: false,
            width: "300",
          },
          model: {
            value: _vm.popupVisible,
            callback: function ($$v) {
              _vm.popupVisible = $$v
            },
            expression: "popupVisible",
          },
        },
        [
          _c("div", { staticClass: "dialog-wrapper" }, [
            _c("div", { staticClass: "content" }, [
              _c("p", [
                _c("span", [_vm._v(_vm._s(_vm.$t("lang.wd.withdrawTips")))]),
                _c("img", {
                  attrs: {
                    src: _vm.getMatchImg("beans"),
                    alt: "coin",
                    width: "24",
                    height: "24",
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "fonter-wrapper" }, [
              _c(
                "div",
                {
                  staticClass: "confirm-btn withdrawAtc",
                  on: { click: _vm.handleDialogClickWithdraw },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("lang.sevenKeepSignin.withdraw")) + " "
                  ),
                ]
              ),
              _c(
                "div",
                {
                  on: {
                    click: function ($event) {
                      _vm.popupVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("lang.commonM.k162")))]
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "van-dialog",
        {
          attrs: {
            title: "",
            showConfirmButton: false,
            showCancelButton: false,
            width: "300",
          },
          model: {
            value: _vm.showNoAuthDia,
            callback: function ($$v) {
              _vm.showNoAuthDia = $$v
            },
            expression: "showNoAuthDia",
          },
        },
        [
          _c("div", { staticClass: "dialog-wrapper" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("lang.inviteHostNew.verification"))),
            ]),
            _c("div", { staticClass: "content" }, [
              _c("p", [
                _c("span", [_vm._v(_vm._s(_vm.$t("lang.commonM.k115")))]),
              ]),
            ]),
            _c("div", { staticClass: "fonter-wrapper" }, [
              _c(
                "div",
                {
                  staticClass: "confirm-btn withdrawAtc",
                  on: { click: _vm.toUserVerify },
                },
                [_vm._v(_vm._s(_vm.$t("lang.commonM.k116")))]
              ),
              _c(
                "div",
                {
                  on: {
                    click: function ($event) {
                      _vm.showNoAuthDia = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("lang.commonM.k162")))]
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "van-dialog",
        {
          attrs: { showConfirmButton: false },
          model: {
            value: _vm.showNotApprovedDialog,
            callback: function ($$v) {
              _vm.showNotApprovedDialog = $$v
            },
            expression: "showNotApprovedDialog",
          },
        },
        [
          _c("div", { staticClass: "dialog not-approved-dialog" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("lang.commonM.k081"))),
            ]),
            _c("div", { staticClass: "not-approved-content" }, [
              _c("div", { staticClass: "info-item" }, [
                _c("div", { staticClass: "item-title" }, [
                  _vm._v(_vm._s(_vm.$t("lang.instantPayment.method"))),
                ]),
                _c("div", { staticClass: "item-value" }, [
                  _vm._v(_vm._s(_vm.notApprovedInfo.withdrawMethod || "-")),
                ]),
              ]),
              _c("div", { staticClass: "info-item" }, [
                _c("div", { staticClass: "item-title" }, [
                  _vm._v(_vm._s(_vm.$t("lang.instantPayment.amount"))),
                ]),
                _c("div", { staticClass: "item-value purple" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.notApprovedInfo.applyAmount
                          ? `≈${
                              _vm.notApprovedInfo.currency
                            } ${_vm.handleUSDollar(
                              _vm.notApprovedInfo.applyAmount
                            )}`
                          : "-"
                      ) +
                      " "
                  ),
                ]),
              ]),
              _c("div", { staticClass: "info-item" }, [
                _c("div", { staticClass: "item-title" }, [
                  _vm._v(_vm._s(_vm.$t("lang.instantPayment.submissionTime"))),
                ]),
                _c("div", { staticClass: "item-value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.notApprovedInfo.createTime
                        ? _vm.handleMoment(
                            _vm.notApprovedInfo.createTime,
                            "DD/MM/YYYY HH:mm:ss"
                          )
                        : "-"
                    )
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "btn" }, [
              _c(
                "span",
                {
                  staticClass: "confirm-btn",
                  on: { click: _vm.handleViewDetail },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("lang.instantPayment.dialogButtonText1"))
                  ),
                ]
              ),
              _c(
                "span",
                {
                  staticClass: "later-btn",
                  on: {
                    click: function ($event) {
                      return _vm.handleCommonSure("showNotApprovedDialog")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("lang.commonM.k162")))]
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "van-dialog",
        {
          attrs: { showConfirmButton: false },
          model: {
            value: _vm.showUsdtBinanceOff1,
            callback: function ($$v) {
              _vm.showUsdtBinanceOff1 = $$v
            },
            expression: "showUsdtBinanceOff1",
          },
        },
        [
          _c("div", { staticClass: "dialog not-approved-dialog" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("lang.commonM.k310"))),
            ]),
            _c("p", [_vm._v(_vm._s(_vm.$t("lang.commonM.k311")))]),
            _c("div", { staticClass: "btn" }, [
              _c(
                "span",
                { staticClass: "confirm-btn", on: { click: _vm.handleToEdit } },
                [_vm._v(_vm._s(_vm.$t("lang.commonM.k312")))]
              ),
              _c(
                "span",
                {
                  staticClass: "later-btn",
                  on: {
                    click: function ($event) {
                      return _vm.handleCommonSure("showUsdtBinanceOff1")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("lang.commonM.k162")))]
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "van-dialog",
        {
          attrs: { showConfirmButton: false },
          model: {
            value: _vm.showUsdtBinanceOff2,
            callback: function ($$v) {
              _vm.showUsdtBinanceOff2 = $$v
            },
            expression: "showUsdtBinanceOff2",
          },
        },
        [
          _c("div", { staticClass: "dialog not-approved-dialog" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("lang.commonM.k310"))),
            ]),
            _c("p", [_vm._v(_vm._s(_vm.$t("lang.commonM.k313")))]),
            _c("div", { staticClass: "btn" }, [
              _c(
                "span",
                {
                  staticClass: "confirm-btn",
                  on: {
                    click: function ($event) {
                      return _vm.handleCommonSure("showUsdtBinanceOff2")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("lang.ok")))]
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }